import { apiClient } from '../../../../api/axios';
import type { ApiResponse, RoleItem } from '../common/types';
import type { MenuPayload, MenuItem, RoleMenuItem, AssignMenuPayload } from './types';

export const menuService = {
    createMenu: async (payload: MenuPayload): Promise<ApiResponse<MenuItem>> => {
        const response = await apiClient.post('/Menus/CreateMenu', payload);
        return response.data;
    },

    updateMenu: async (payload: MenuPayload): Promise<ApiResponse<MenuItem>> => {
        const response = await apiClient.post('/Menus/UpdateMenu', payload);
        return response.data;
    },

    getAllMenu: async (status?: boolean): Promise<ApiResponse<MenuItem[]>> => {
        const url = status !== undefined ? `/Menus/GetAllMenu?status=${status}` : '/Menus/GetAllMenu';
        const response = await apiClient.get(url);
        return response.data;
    },

    assignMenuToRole: async (payload: AssignMenuPayload): Promise<ApiResponse<number>> => {
        const response = await apiClient.post('/Menus/AssignMenuToRole', payload);
        return response.data;
    },

    deleteMenuFromRole: async (id: number): Promise<ApiResponse<boolean>> => {
        const response = await apiClient.post(`/Menus/DeleteMenuInRole?Id=${id}`);
        return response.data;
    },

    getAdminRoles: async (): Promise<ApiResponse<RoleItem[]>> => {
        const response = await apiClient.get('/Roles/GetRoles');
        return response.data;
    },

    getUserCreationRoles: async (): Promise<ApiResponse<RoleItem[]>> => {
        const response = await apiClient.get('/Roles/GetRolesForUserCreation');
        return response.data;
    },

    getMenuByRoleId: async (roleId: number, status?: boolean): Promise<ApiResponse<RoleMenuItem[]>> => {
        const url = status !== undefined
            ? `/Menus/GetMenuByRole?roleId=${roleId}&status=${status}`
            : `/Menus/GetMenuByRole?roleId=${roleId}`;
        const response = await apiClient.get(url);
        return response.data;
    },

    getSideMenuByRole: async (): Promise<ApiResponse<MenuItem[]>> => {
        const response = await apiClient.get('/Menus/GetSideMenuByRole');
        return response.data;
    }
};
